import { Locale } from "../Locale.js";
import type { LocalizedString } from "../Locale.js";
import { PaymentType } from "../PaymentType.js";

export const paymentTypeNameMap: Record<PaymentType, LocalizedString> = {
	[PaymentType.GoPayPaymentCard]: { [Locale.cs]: "Kartou" },
	[PaymentType.GoPayQRCode]: { [Locale.cs]: "QR" },
	[PaymentType.GoPayGPay]: { [Locale.cs]: "Google Pay" },
	[PaymentType.GoPayApplePay]: { [Locale.cs]: "Apple Pay" },
	[PaymentType.OnDelivery]: { [Locale.cs]: "Dobírkou" },
	[PaymentType.OnInvoice]: { [Locale.cs]: "Na fakturu" },
};

export const paymentTypeNameMapForAdmin: Record<PaymentType, LocalizedString> = {
	...paymentTypeNameMap,
	[PaymentType.GoPayPaymentCard]: { [Locale.cs]: "Kartou - online převodem" },
	[PaymentType.GoPayQRCode]: { [Locale.cs]: "QR - online převodem" },
	[PaymentType.OnDelivery]: { [Locale.cs]: "Dobírkou - hotově nebo kartou na místě" },
};

export const paymentTypeLongNameMap: Record<PaymentType, LocalizedString> = {
	[PaymentType.GoPayPaymentCard]: { [Locale.cs]: "Platební kartou" },
	[PaymentType.GoPayQRCode]: { [Locale.cs]: "QR kódem" },
	[PaymentType.GoPayGPay]: { [Locale.cs]: "Google Pay" },
	[PaymentType.GoPayApplePay]: { [Locale.cs]: "Apple Pay" },
	[PaymentType.OnDelivery]: { [Locale.cs]: "Platba na místě hotově nebo kartou" },
	[PaymentType.OnInvoice]: { [Locale.cs]: "Úhrada na fakturu převodem" },
};
